export const Footer = () => {
  return (
    <footer className="text-slate-50 font-sans relative w-full text-center p-4 bg-zinc-900">
      Coded with ❤ by{" "}
      <a
        className="font-semibold text-inherit no-underline"
        href="https://github.com/nshaikhinurov/clock-app/"
      >
        nshaikhinurov
      </a>
    </footer>
  );
};
